/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable-next-line no-unused-vars */
import { Route, Routes } from "react-router-dom";

import LandingPage from "pages/LandingPage";
import ProjectPage from "pages/ProjectPage";
import NotFoundPage from "pages/NotFoundPage";
import TeamPage from "pages/TeamPage";

import { ProjectDetailPage } from "pages/ProjectDetailPage";
import { DiscussProjectPage } from "pages/DiscussProjectPage";

import "./assets/css/styles.css";
import ContactPage from "pages/ContactPage";

import TechnologyInfrastructurePage from "pages/TechnologyInfrastructurePage";
import TargetMarketSegmentPage from "pages/TargetMarketSegmentPage";
import CompetitiveAdvantagesPage from "pages/CompetitiveAdvantagesPage";
import BusinessStructurePage from "pages/BusinessStructurePage";
import CoreServicesLineComponent from "parts/CoreServicesLineComponent";
import MarketingAndClientAcquisitionStrategyPage from "pages/MarketingAndClientAcquisitionStrategyPage";
import SampleRevenueForecastPage from "pages/SampleRevenueForecastPage";
import LegalAndCompliancePage from "pages/LegalAndCompliancePage";
import ServicesPage from "pages/ServicesPage";

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        <Route path="/project" element={<ProjectPage />} />
        <Route exact path="/project/:id" element={<ProjectDetailPage />} />
        <Route exact path="/team" element={<TeamPage />} />
        <Route exact path="/discuss-project" element={<DiscussProjectPage />} />
        <Route exact path="/contact" element={<ContactPage />} />
        <Route path="**" element={<NotFoundPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route
          path="/services/core-service-lines-and-revenue-streams"
          element={<CoreServicesLineComponent />}
        />
        <Route
          path="/services/technology-infrastructure"
          element={<TechnologyInfrastructurePage />}
        />
        <Route
          path="/services/target-market-segment"
          element={<TargetMarketSegmentPage />}
        />
        <Route
          path="/services/competitive-advantages"
          element={<CompetitiveAdvantagesPage />}
        />
        <Route
          path="/services/business-structure"
          element={<BusinessStructurePage />}
        />
        <Route
          path="/services/marketing-and-client-acquisition-strategy"
          element={<MarketingAndClientAcquisitionStrategyPage />}
        />
        <Route
          path="/services/sample-revenue-forecast"
          element={<SampleRevenueForecastPage />}
        />
        <Route
          path="/services/legal-and-compliance"
          element={<LegalAndCompliancePage />}
        />
      </Routes>
    </>
  );
}

export default App;
